<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

// Aceleres 2026-08-18: a última reação da conversa aparece na lista como no
// WhatsApp — "Reagiu com ❤️ a: bom dia". A reação não é uma mensagem: ela vive
// nos `content_attributes` da mensagem REAGIDA, que quase nunca é a última da
// conversa. Quem guarda o resumo é a própria conversa, em
// `additional_attributes.last_reaction` (ver Aceleres::ConversationReactionPreview).
//
// Este componente é irmão de MessagePreview/DraftPreview/VoiceCallStatus: o
// cartão escolhe um dos quatro, seguindo o mesmo encadeamento que já existia.
const props = defineProps({
  reaction: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const emoji = computed(() => props.reaction?.emoji || '');

// O trecho da mensagem reagida. Sem texto (foto, áudio, documento) usa o mesmo
// rótulo que a prévia normal da lista mostraria para aquele anexo, para as duas
// linhas falarem a mesma língua.
const reactedContent = computed(() => {
  const content = (props.reaction?.content || '').trim();
  if (content) return content;

  const fileType = props.reaction?.file_type;
  if (fileType) {
    const key = `CHAT_LIST.ATTACHMENTS.${fileType}.CONTENT`;
    const label = t(key);
    if (label !== key) return label;
  }

  return t('CHAT_LIST.NO_CONTENT');
});

// A reação do contato não leva nome porque numa conversa individual só existe
// um contato — é o que o WhatsApp faz. A nossa leva "Você" para o agente
// distinguir de imediato o que ele mesmo fez.
const label = computed(() =>
  props.reaction?.from_contact
    ? `Reagiu com ${emoji.value} a: ${reactedContent.value}`
    : `Você reagiu com ${emoji.value} a: ${reactedContent.value}`
);
</script>

<template>
  <div
    class="overflow-hidden text-ellipsis whitespace-nowrap"
    :title="label"
    data-preview="reaction"
  >
    {{ label }}
  </div>
</template>
